export const ProjectsData = [
    {
        ProjectName:"Cult.fit Clone",
        ProjectDescription:"This is a clone of a website called cult.fit. Here you can schedule a workout session of your choice as per the date and time slot provided. You can also change the location to see where the slots are available.",
        GithubLink:"https://github.com/pratikjadhav080/Cult-Fit-Client",
        LiveDemoLink:"https://cult-fit-client.vercel.app/",
        MediumLink:"https://medium.com/@NagendraPatil/building-cult-fit-clone-in-6-days-c6a72ad731a0",
        TechUsed:["React","Redux","Express","MongoDB","GoogleAuth","NPM"],
        year:"Dec 2021",
        image:"./icons/cultfit.png"
    },
    {
        ProjectName:"Mental Health App",
        ProjectDescription:"This project looks after the health and wellness of the User. You will find a feature to schedule an appointment with our doctor. You can also post your issues here, reply on other’s issues and like/dislike any post.",
        GithubLink:"https://github.com/pratikjadhav080/Mental-Health",
        LiveDemoLink:"https://mental-health-client.vercel.app/",
        MediumLink:"https://medium.com/@pratikjadhav080/built-a-mental-health-application-using-react-js-6e264696ca28",
        TechUsed:["React","Express","Node","MongoDB","GoogleAuth","FacebookAuth","NPM"],
        year:"Nov 2021",
        image:"./icons/mentalhealth.png"
    },
    {
        ProjectName:"Nordstrom Clone",
        ProjectDescription:"Nordstrom is an American e-commerce website. In this project we have cloned some important features of the website with backend integration. We used NodeJS runtime, Express framework and MongoDB as database.",
        GithubLink:"https://github.com/pratikjadhav080/Nordstrom-clone",
        LiveDemoLink:"https://nordstrom-cloned.herokuapp.com/",
        MediumLink:"https://medium.com/@pratikjadhav080/we-created-nordstrom-clone-using-backend-7044716bc7b7",
        TechUsed:["JAVASCRIPT","MongoDB","Express","HTML","CSS"],
        year:"Sep 2021",
        image:"./icons/Nordstrom.png"
    }
]